








import { Route } from 'vue-router'
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class DebugTableLayout extends Vue {
  public debug = 0

  public async created() {
    const route: Route = this.$route
    this.debug = parseInt(route.query.debug + '', 10) || 0
  }
}
